import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Grid2 as Grid,
    IconButton,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import EventOverview from './EventOverview';
import useEventContext from '@hooks/useEventContext';
import { useNavigate } from 'react-router';
import { RegisterNowButton } from './RegisterNowButton';
import { RegisteredWrestlersButton } from './RegisteredWrestlersButton';
import LoadingPaper from '@atoms/LoadingPaper';

interface Props {
    // event: Event | null;
    onClose: () => void;
    open: boolean;
}

export default function EventDetailModal({ onClose, open }: Props) {
    const { event, isEventAdmin, loading } = useEventContext();
    const navigate = useNavigate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    // FIXME: this modal originally renders the previous event you were viewing, we should be showing a loading indicator or something else...
    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth
            maxWidth={'lg'}
            open={open}
            onClose={onClose}
            sx={{ zIndex: 1000 }} // show below other modals which are 1300
        >
            <LoadingPaper loading={loading} sx={{ padding: 4 }}>
                <DialogTitle>
                    {/* <Box
                        position="relative"
                        display="flex"
                        flexDirection="row"
                        justifyContent="space-between"
                        flex={1}
                        overflow="hidden"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                    >
                        <Box maxWidth="18rem" flexGrow={0.5}> */}
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography
                                overflow="hidden"
                                whiteSpace="nowrap"
                                textOverflow="ellipsis"
                            >
                                Event Details: {event?.name || 'New Event'}
                            </Typography>

                            {event?.description ? (
                                <Typography
                                    overflow="hidden"
                                    whiteSpace="nowrap"
                                    textOverflow="ellipsis"
                                    fontSize={12}
                                >
                                    {event?.description}
                                </Typography>
                            ) : null}
                        </Grid>
                        {/* </Box> */}

                        <Grid size={{ xs: 12, md: 8 }}>
                            <Stack
                                flexDirection={'row'}
                                justifyContent={'flex-end'}
                                divider={
                                    <Divider orientation="vertical" flexItem sx={{ marginX: 2 }} />
                                }
                            >
                                {event ? (
                                    <>
                                        <Box>
                                            <RegisteredWrestlersButton event={event} />
                                        </Box>
                                        <Box>
                                            <RegisterNowButton event={event} />
                                        </Box>
                                    </>
                                ) : null}
                                {isEventAdmin ? (
                                    <Box>
                                        <IconButton
                                            sx={{ flexShrink: 0.1, position: 'flex-end' }}
                                            onClick={() => {
                                                if (event) {
                                                    onClose();
                                                    navigate(`/events/${event.id}`);
                                                }
                                            }}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    </Box>
                                ) : null}
                            </Stack>
                        </Grid>
                    </Grid>
                    {/* </Box> */}
                    <Divider sx={{ paddingTop: 2 }} />
                </DialogTitle>
                <DialogContent>
                    <EventOverview previewOnly />
                </DialogContent>
            </LoadingPaper>
        </Dialog>
    );
}
